(() => {
  // Rotation is CSS-driven, but we enable the animation only after the page is ready.
  // This prevents the "multiple announcements visible" flash on immediate open after reload.
  const START_ATTR = 'data-cdj-announcement-animate';

  /**
   * @param {Document | HTMLElement} context
   */
  function enableAnimation(context = document) {
    const roots = context.querySelectorAll?.('[data-cdj-announcement]');
    if (!roots?.length) return;

    roots.forEach((root) => {
      if (!(root instanceof HTMLElement)) return;
      // Only start animation if we actually have multiple slides and rotate is enabled.
      const slides = root.querySelectorAll('[data-cdj-announcement-slide]');
      if (slides.length <= 1) return;
      if (root.getAttribute('data-cdj-announcement-rotate') !== 'true') return;

      root.setAttribute(START_ATTR, 'true');
    });
  }

  function boot() {
    // Defer one paint so inline opacity (slide1=1, others=0) wins on first open.
    requestAnimationFrame(() => enableAnimation(document));

    // If cart drawer is re-rendered later, enable animation again for new markup.
    const cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer && 'MutationObserver' in window) {
      const mo = new MutationObserver(() => enableAnimation(cartDrawer));
      mo.observe(cartDrawer, { subtree: true, childList: true });
    }
  }

  /**
   * @typedef {Document | HTMLElement} SearchContext
   */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

